export const googleFontsKeys = {
  all: () => ['google-fonts'] as const,
};
